import { Currency, Price, Token } from '@kodiak-finance/sdk-core'
import { AutoColumn } from 'components/Column'
import StepCounter from 'components/InputStepCounter/InputStepCounter'
import { RowBetween } from 'components/Row'
import { Bound } from 'state/mint/v3/actions'
import { toSorted } from 'state/mint/v3/utils'

type Props = {
  priceLower?: Price<Token, Token>
  priceUpper?: Price<Token, Token>

  getDecrementLower: () => void
  getIncrementLower: () => void
  getDecrementUpper: () => void
  getIncrementUpper: () => void

  onLeftRangeInput: (typedValue: string) => void
  onRightRangeInput: (typedValue: string) => void

  currencyA?: Currency | null
  currencyB?: Currency | null
  feeAmount?: number

  ticksAtLimit: { [bound in Bound]?: boolean | undefined }
  invertPrice?: boolean

  // NEW: direct tick values & tick setters
  tickLower?: number
  tickUpper?: number
  onLeftRangeTickInput: (tick: number | undefined) => void
  onRightRangeTickInput: (tick: number | undefined) => void

  inputsDisabled?: boolean
}

// currencyA is the base token
export default function RangeSelector({
  priceLower,
  priceUpper,
  getDecrementLower,
  getIncrementLower,
  getDecrementUpper,
  getIncrementUpper,
  onLeftRangeInput,
  onRightRangeInput,
  currencyA,
  currencyB,
  feeAmount,
  ticksAtLimit,
  tickLower,
  tickUpper,
  onLeftRangeTickInput,
  onRightRangeTickInput,
  invertPrice,
  inputsDisabled = false,
}: Props) {
  const tokenA = (currencyA ?? undefined)?.wrapped
  const tokenB = (currencyB ?? undefined)?.wrapped
  const [sorted0, sorted1] = toSorted(tokenA, tokenB)

  const leftTick = invertPrice ? tickUpper : tickLower
  const rightTick = invertPrice ? tickLower : tickUpper

  const onLeftTickInput = onLeftRangeTickInput
  const onRightTickInput = onRightRangeTickInput

  const leftInc = invertPrice ? getDecrementUpper : getIncrementLower
  const leftDec = invertPrice ? getIncrementUpper : getDecrementLower
  const rightInc = invertPrice ? getDecrementLower : getIncrementUpper
  const rightDec = invertPrice ? getIncrementLower : getDecrementUpper

  // const isFullRange = Boolean(ticksAtLimit[Bound.LOWER] && ticksAtLimit[Bound.UPPER])

  return (
    <AutoColumn gap="md">
      <RowBetween>
        <StepCounter
          tick={leftTick}
          onTickInput={onLeftTickInput}
          incrementTick={leftInc}
          decrementTick={leftDec}
          baseToken={sorted0}
          quoteToken={sorted1}
          feeAmount={feeAmount}
          invertPrice={invertPrice}
          width="48%"
          locked={inputsDisabled}
          // decrementDisabled={Boolean(ticksAtLimit[invertPrice ? Bound.UPPER : Bound.LOWER]) || isFullRange}
          // incrementDisabled={isFullRange}
          title={<>Min Price</>}
          tokenA={currencyA?.symbol}
          tokenB={currencyB?.symbol}
        />

        <StepCounter
          tick={rightTick}
          onTickInput={onRightTickInput}
          incrementTick={rightInc}
          decrementTick={rightDec}
          baseToken={sorted0}
          quoteToken={sorted1}
          feeAmount={feeAmount}
          invertPrice={invertPrice}
          width="48%"
          locked={inputsDisabled}
          // decrementDisabled={isFullRange}
          // incrementDisabled={Boolean(ticksAtLimit[invertPrice ? Bound.LOWER : Bound.UPPER]) || isFullRange}
          title={<>Max Price</>}
          tokenA={currencyA?.symbol}
          tokenB={currencyB?.symbol}
        />
      </RowBetween>
    </AutoColumn>
  )
}
